module.exports = __webpack_public_path__ + "img/rule5.691d088b.png";